/*
 * Sticky Header
 */
const body = document.body;
const nav = document.querySelector('#header');
const hero = document.querySelector('#hero-header');

// const navSticky = document.querySelector('#nav-sticky');

// const stickyHeader = document.getElementById('masthead');
// const stickyPreNav = document.querySelector('#masthead .pre-nav');
// const adFixedtop = document.querySelector('.ad-fixed-top');

// const scrollUp = 'scroll-up';
// const scrollDown = 'scroll-down';
// let lastScroll = 0;

// window.addEventListener('scroll', function (ev) {
//   const scrollTop =
//     window.pageYOffset ||
//     document.documentElement.scrollTop ||
//     document.body.scrollTop ||
//     0;
//   const currentScroll = window.pageYOffset;
//   //const stickyHeader = document.getElementById("masthead");

//   //console.log(stickyHeader.offsetHeight);
//   //console.log(scrollTop);stickyHeader.offsetHeight

//   if (currentScroll == 0) {
//     body.classList.remove(scrollUp);
//     body.classList.remove(scrollDown);
//     return;
//   }

//   if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
//     // down
//     body.classList.remove(scrollUp);
//     body.classList.add(scrollDown);

//     //stickyHeader.style.top = '-' + (stickyPreNav.offsetHeight + 36) + 'px';
//   } else if (
//     currentScroll < lastScroll &&
//     body.classList.contains(scrollDown)
//   ) {
//     // up
//     body.classList.remove(scrollDown);
//     body.classList.add(scrollUp);
//     //       stickyHeader.style.top=0;
//   }
//   lastScroll = currentScroll;

//   // console.log(
//   //   scrollTop,
//   //   stickyHeader.offsetHeight + adFixedtop.offsetHeight + 10
//   // );

//   if (scrollTop > stickyHeader.offsetHeight + adFixedtop.offsetHeight + 10) {
//     nav.classList.add('isSticky');

//     //console.log(stickyHeader.offsetHeight);

//     document.querySelectorAll('.sticky-header').forEach(stickyHeaderElement => {
//       let margin = 10;

//       if (stickyHeaderElement.dataset.stickyMargin) {
//         if (stickyHeaderElement.dataset.stickyMargin == '0') {
//           margin = 0;
//         } else {
//           margin = parseInt(stickyHeaderElement.dataset.stickyMargin);
//         }
//       }

//       stickyHeaderElement.style.top = nav.offsetHeight + margin + 'px';
//     });
//   } else {
//     nav.classList.remove('isSticky');
//   }
// });

// document.querySelector('body').addEventListener('is.inread-loaded', e => {
//   if (e.detail.postID) {
//     let currentArticle = document.getElementById('post-' + e.detail.postID);
//     let mainInread = currentArticle.querySelector('.ad-main-inread');
//     if (mainInread) observer.observe(mainInread);
//   }
// });

// const stickyAds = document.querySelectorAll('.sticky-ad');
const config = {
  root: null,
  rootMargin: '0px 0px 0px',
  threshold: 0,
};

// console.log(hero);
let isHeroVisible = false;
const observer = new IntersectionObserver(function (entries, observer) {
  entries.forEach(entry => {
    // console.log(entry.intersectionRatio);

    if (entry.intersectionRatio === 0) {
      nav.classList.add('isSticky');
      if (typeof $bp === 'function' && $bp('hero-video').isReady) {
        console.log('Video Hero Pause');

        $bp('hero-video').pause();
      }
    } else {
      nav.classList.remove('isSticky');
      if (typeof $bp === 'function' && $bp('hero-video').isReady) {
        console.log('Video Hero Play');
        $bp('hero-video').play();
      }
    }

    // if (!isHeroVisible) {
    //   isHeroVisible = false;
    //   console.log(isHeroVisible);
    //   nav.classList.add('isSticky');
    // }
    // if (entry.isIntersecting) {
    //   console.log('Radio', entry.intersectionRatio);

    //   if (entry.intersectionRatio > 0.9) {
    //     console.log('Interseccion', entry);
    //     //nav.classList.add('isSticky');
    //     //console.log(fixedAd);
    //     // fixedAd.classList.contains('sticky-top')
    //     //   ? fixedAd.classList.remove('sticky-top')
    //     //   : '';
    //   } else {
    //     // console.log('Out');
    //   }
    // } else {
    //   //console.log('Out');
    // }
    // // else {
    // //   !fixedAd.classList.contains('not-sticky')
    // //     ? fixedAd.classList.add('sticky-top')
    // //     : '';
    // // }
  });
}, config);

observer.observe(hero);

hero.addEventListener(
  'mouseenter',
  function (event) {
    if (typeof $bp === 'function' && $bp('hero-video').isReady) {
      console.log('Video Hero Play on Enter');
      $bp('hero-video').play();
    }
  },
  false
);
hero.addEventListener(
  'touchstart',
  function (event) {
    if (typeof $bp === 'function' && $bp('hero-video').isReady) {
      console.log('Video Hero Play on Touch');
      $bp('hero-video').play();
    }
  },
  false
);
// stickyAds.forEach(stickyAd => {
//   observer.observe(stickyAd);
// });
